import { classnames } from 'Utils/classnames/classnames.utils';

import { COLORS } from 'Components/utils/color/colors';

export const BUTTON_SIZES = {
  small: 'min-h-36',
  medium: 'min-h-40',
  large: 'min-h-48',
};

const getCursor = ({ isDisabled, isLoading }) => {
  let cursor = isLoading ? 'cursor-wait' : 'cursor-pointer';
  if (isDisabled) {
    cursor = 'cursor-not-allowed';
  }
  return cursor;
};

const getColors = ({
  color = COLORS.BLACK,
  colorBg = COLORS.SAFFRON,
  colorBorder = COLORS.SAFFRON,
  isDisabled,
  isLoading,
}) => {
  if (isDisabled) {
    return 'disabled:bg-pearl disabled:border-pearl disabled:text-grey';
  }

  return classnames(
    'border-saffron bg-saffron text-black',
    `bg-${colorBg} border-${colorBorder} text-${color}`,
    {
      [`hocus:bg-${colorBg}-active hocus:border-${colorBorder}-active hocus:text-${color}-active`]:
        !isLoading,
    },
  );
};

const getDefault = (props) => ({
  thButton: classnames(
    'inline-flex items-center justify-center gap-10 overflow-hidden rounded-pill text-14 font-bold transition-colors duration-250 ease-in',
    BUTTON_SIZES[props.size],
    getColors(props),
    getCursor(props),
    {
      'border-1 border-solid': props.colorBorder,
      'aspect-square': props.isSquare,
      'px-20 py-5': !props.isSquare,
    },
  ),
  thIcon: 'shrink-0',
  thSpinner: 'shrink-0 leading-0',
});

export const themes = (props) => ({
  default: getDefault(props),
  link: {
    ...getDefault(props),
    thStyle: {},
    thButton: classnames(
      'flex items-center justify-between gap-10 bg-transparent text-14 underline transition-colors duration-250 ease-in',
      getCursor(props),
    ),
    thSpinner: 'hidden',
  },
});
